export const MIN_KUDOS_CARD_WIDTH = 170;
export const MIN_KUDOS_CARD_WIDTH_LARGE = 280;
